import React, { MouseEventHandler } from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import PbxListItem from './PbxListItem';
import BetaBadge from '../badges/BetaBadge';
import { RowMarking } from './BaseListItem';

interface Props {
    onClick?: MouseEventHandler;
    isBeta?: boolean;
    marking?: RowMarking;
}

const ListItemSupervisor = ({ onClick, isBeta, marking }: Props) => {
    const { i18next } = useAppContext();
    return (
        <PbxListItem
            onClick={onClick}
            marking={marking}
            type="overview"
            title={i18next.t('messages.overview')}
        >
            {isBeta && (
                <div className="flex" data-test-id="card-title-item-third">
                    <BetaBadge />
                </div>
            )}
        </PbxListItem>
    );
};

export default ListItemSupervisor;
